export const googleAnalyticsConfig = import.meta.env.VITE_GA_MEASUREMENT_ID;
